//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const caloriesRelationship = useStore((state) => state.caloriesRelationship);
  const setCaloriesRelationship = useStore((state) => state.setCaloriesRelationship);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.caloriesRelationship.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={caloriesRelationship}
          onChange={(value) => {
            setCaloriesRelationship(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'calories-relationship',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Yes, calorie intake affects body weight'}>
            <span>👍</span> {t('onboarding.caloriesRelationship.options.affectsBodyWeight')}
          </Option>
          <Option value={'Somewhat, calories impact weight'}>
            <span>🤔</span> {t('onboarding.caloriesRelationship.options.impactWeight')}
          </Option>
          <Option value={"No, I'm not sure how calories influence weight"}>
            <span>🤷‍♀️</span> {t('onboarding.caloriesRelationship.options.influenceWeight')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
